import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { createAppRouter } from "./routes";
import { RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { setupKeycloakInstance } from './libs/auth/keycloakInstance';
import { NotificationProvider } from './libs/notifications/NotificationProvider';

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}

console.log(`Main.tsx initialising in ${import.meta.env.MODE} mode`)

;(async () => {
  const kc = setupKeycloakInstance();
  await kc.init({ pkceMethod: 'S256', checkLoginIframe: false });

  const queryClient = new QueryClient();
  const router = createAppRouter({ queryClient: undefined! });

  const rootElement = document.getElementById('root')!
  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <NotificationProvider>
            <RouterProvider
              router={router}
              context={{ queryClient }}
            />
          </NotificationProvider>
        </QueryClientProvider>
      </StrictMode>
    )
  }
})();
